import React from 'react';

import { Box, Stack } from '@mui/material';

import type { AutomaticRefundDetailsProps } from './types';

export default function BedbankAutomaticRefundDetails({
  customer_full_name,
  reason,
  comment,
  source,
  markCancelled,
  currencyCode,
  totalRefund,
}: AutomaticRefundDetailsProps) {
  return (
    <Box>
      <h4>Refund Summary</h4>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>Customer Name</small>
        </Box>
        <Box>
          <small>{customer_full_name}</small>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>Refund Category</small>
        </Box>
        <Box>
          <small>{reason}</small>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>Customer's reason</small>
        </Box>
        <Box>
          <small>{comment}</small>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>Source of Fund</small>
        </Box>
        <Box>
          <small>{source}</small>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>Room Cancelled</small>
        </Box>
        <Box>
          <small>{markCancelled}</small>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Box>
          <small>
            <b>Customer Refund Amount {currencyCode}</b>
          </small>
        </Box>
        <Box>
          <small>{totalRefund}</small>
        </Box>
      </Stack>
    </Box>
  );
}
